import { render, staticRenderFns } from "./ledger-form.vue?vue&type=template&id=68c50932&lang=html&"
import script from "./ledger-form.vue?vue&type=script&lang=js&"
export * from "./ledger-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports